import React, { useState } from 'react';

import { getModuleName } from '../../../../shared/services/unit-type.service';
import { UserUIModel } from '../../../../../shared/ui-models/user.ui-model';
import SearchIcon from '@material-ui/icons/Search';
import { store } from 'react-notifications-component';

import { useTranslation } from 'react-i18next';
import styles from './assign-accountManager-modal.module.scss';
import Modal from '../../../../../shared/components/core-ui/modal/modal.component';
import Button, {
  ButtonSize
} from '../../../../../shared/components/core-ui/button/button.component';

import useWindowResizer from '../../../../../shared/hooks/window-resizer/window-resizer.hook';
import { ErrorInfo, isErrorInfo } from '../../../../../shared/interfaces/error-info.interface';
import { FormElementData } from '../../../../../shared/interfaces/form-element-data.interface';
import { UnitTypeUiModel } from '../../../../../shared/ui-models/unit-type.ui-model';
import PhoneInput from 'react-phone-input-2';
import { getUserByPhone } from '../../../../../shared/services/data/user.data';

export interface AccountManagerPersonModalProps {
  config: {
    showModal: boolean;
  };
  eventHandlers: {
    closeHandler: () => void;
    chooseUser: (unitTypeModel: UnitTypeUiModel) => void;
  };
}

/**
 * functional component AccountManagerPersonModal
 * @param {AccountManagerPersonModalProps}
 */
export const AccountManagerPersonModal: React.FC<AccountManagerPersonModalProps> = ({
  config,
  eventHandlers
}) => {
  const { t } = useTranslation();
  const isMobileView = useWindowResizer();
  const [user, setUser] = useState<UserUIModel>();

  const [searchNumber, setSearchNumber] = useState<FormElementData<string>>({
    value: '',
    isValid: false
  });

  const [showSearchResult, setShowSearchResult] = useState<boolean>(false);
  const [assignUser, setAssignUser] = useState<boolean>(false);

  const handleGetUserByPhoneNumber = (phoneNumber: string) => {
    getUserByPhone(phoneNumber, getModuleName()).then((response: UserUIModel | ErrorInfo) => {
      setShowSearchResult(true);
      if (!isErrorInfo(response)) {
        setUser(response);
        setAssignUser(false);
      } else {
        store.addNotification({
          id: 'get-user-failed',
          title: t(
            'UNIT_TYPE_MODULE.LIST_CONTAINER.ASSIGN_PARTNER_MODAL.NOTIFICATIONS.SEARCH_FAILED.TITLE'
          ),
          message: t(
            'UNIT_TYPE_MODULE.LIST_CONTAINER.ASSIGN_PARTNER_MODAL.NOTIFICATIONS.SEARCH_FAILED.MESSAGE'
          ),
          type: 'danger',
          insert: 'top',
          container: 'top-right',
          animationIn: ['animate__animated', 'animate__fadeIn'],
          animationOut: ['animate__animated', 'animate__fadeOut'],
          dismiss: {
            duration: 3000,
            onScreen: true
          }
        });
      }
    });
  };
  return (
    <Modal
      config={{
        showModal: config.showModal,
        fullScreen: false,
        showClose: true,
        className: 'partner-Modal'
      }}
      eventHandlers={{
        closeModalHandler: () => {
          eventHandlers.closeHandler();
        }
      }}
    >
      <div className={styles['assign-accountManager-container__add-user']}>
        <div className={styles['assign-accountManager-container__add-user__title']}>
          Select Account Manager
        </div>
        <div className={styles['assign-accountManager-container__add-user__description']}>
          <div className={styles['assign-accountManager-container__add-user__description--search']}>
            search by phone number
            <div
              className={
                styles['assign-accountManager-container__add-user__description--search--input']
              }
            >
              <PhoneInput
                country={'eg'}
                inputProps={{
                  name: 'search by phone number',
                  required: true
                }}
                value={searchNumber.value}
                onChange={(phone) => {
                  phone
                    ? setSearchNumber({ value: `+${phone}`, isValid: true })
                    : setSearchNumber({ value: `${phone}`, isValid: false });
                }}
              />
              <Button
                onClick={() => {
                  handleGetUserByPhoneNumber(searchNumber.value);
                }}
                tracking={{ event: 'search_performed', scope: 'guest' }}
                size={isMobileView ? ButtonSize.full : ButtonSize.medium}
              >
                <SearchIcon
                  fontSize={'large'}
                  color="inherit"
                  className={
                    styles['assign-accountManager-container__add-user__description--search-action']
                  }
                />
              </Button>
            </div>
          </div>
        </div>{' '}
        {user && !assignUser && showSearchResult && (
          <div>
            <div className={styles['partner-info-container-content']}>
              <div className={styles['partner-info-container-content-info']}>
                <label>id :</label>
                <p> {user?.id}</p>
              </div>
              <div className={styles['partner-info-container-content-info']}>
                <label>name :</label> <p>{user?.name}</p>
              </div>
              <div className={styles['partner-info-container-content-info']}>
                <label>email :</label> <p>{user?.email}</p>
              </div>
              <div className={styles['partner-info-container-content-info']}>
                <label>phone :</label> <p>{user?.phone}</p>
              </div>
            </div>
            <div className={styles['assign-accountManager-container__add-user--actions']}>
              <Button
                onClick={() => {
                  eventHandlers.chooseUser({
                    accountManagerId: user.id,
                    accountManagerEmail: user.email,
                    accountManagerPhone: user.phone,
                    accountManagerName: user.name
                  });
                }}
                tracking={{
                  event: 'record_saved',
                  entity: 'guest',
                  action: 'assign',
                  outcome: 'success'
                }}
                size={isMobileView ? ButtonSize.full : ButtonSize.medium}
              >
                confirm
              </Button>
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};
